import {
  Component,
  EventEmitter,
  Injector,
  Output,
  ViewChild,
  OnInit,
} from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
  CurrentUserProfileEditDto,
  SettingScopes,
  ProfileServiceProxy,
  UpdateGoogleAuthenticatorKeyOutput,
  SendVerificationSmsInputDto,
  StaffsAndUsersServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { SmsVerificationModalComponent } from './sms-verification-modal.component';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'mySettingsModal',
  templateUrl: './my-settings-modal.component.html',
})
export class MySettingsModalComponent
  extends AppComponentBase
  implements OnInit {
  @ViewChild('mySettingsModal', { static: true }) modal: ModalDirective;
  @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

  public active = false;
  public saving = false;

  public user;

  isMultiTenancyEnabled: boolean = this.multiTenancy.isEnabled;
  isTwoFactorLoginEnabledForApplication = false;

  constructor(
    injector: Injector,
    private _profileService: ProfileServiceProxy,
    private _staffsAndUsersService: StaffsAndUsersServiceProxy
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.isTwoFactorLoginEnabledForApplication = abp.setting.getBoolean(
      'Abp.Zero.UserManagement.TwoFactorLogin.IsEnabled'
    );
  }

  show(): void {
    this.active = true;

    this._staffsAndUsersService
      .getMyOwnStaffUserForEdit()
      .subscribe((result) => {
        this.user = result;
        this.modal.show();
      });
  }

  onShown(): void {}

  close(): void {
    this.active = false;
    this.modal.hide();
  }
}
